import Box from '@mui/joy/Box'
import Card from '@mui/joy/Card'
import CardContent from '@mui/joy/CardContent'
import Divider from '@mui/joy/Divider'
import Typography from '@mui/joy/Typography'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

export const SupportInfo = ({ data }) => {
    return (
        <Card
            variant="solid"
            color="primary"
            invertedColors
            sx={{
                maxHeight: 'max-content',
                maxWidth: '100%',
                width: '50%',
                overflow: 'auto',
            }}
        >
            <Typography level="title-lg" startDecorator={<InfoOutlined />}>
                Need Help?
            </Typography>
            <Typography level="title-md">{data.message}</Typography>
            <Divider inset="none" />
            <CardContent sx={{ gap: 1, mb: 2 }}>
                <Box>
                    <b>Email:</b> {data.email}
                </Box>
                <Box>
                    <b>Phone:</b> {data.number}
                </Box>
            </CardContent>
        </Card>
    )
}
